// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__rxB5Q","flip":"Icon_flip__8LzXU"};